import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** lightbulb, remembering. Decorative line icon; always pair with a visible text label. */
export function RememberIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M12 3a5.5 5.5 0 0 0-3.2 10c.7.5 1.2 1.2 1.2 2v1h4v-1c0-.8.5-1.5 1.2-2A5.5 5.5 0 0 0 12 3z" />
      <path d="M9.5 18.5h5" />
      <path d="M10.5 21h3" />
    </IconSvg>
  )
}
